<template>
  <div>
    <Field :rules="requiredRule" name="oneTimePassword" v-slot="{ field, errors: errs }">
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('EnterOTPLabel')"
        :max-length="10"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full"
        label-class="w-full"
        direction="flex-col"
      >
        <template #bottomAppendage>
          <span v-if="otpConfig.isSent && otpConfig.timerHalfLife > 0">
            {{ $t('otpParagraph2', { countdown: otpConfig.timerHalfLife }) }}
          </span>
          <button v-else class="text-start text-primary" @click.prevent="onResendOtp">
            {{ $t('resend') }}
          </button>
        </template>
      </TextInput>
    </Field>
    <Field :rules="requiredRule" name="typeOfChange" v-slot="{ field, errors: errs, handleChange }">
      <RadioGroup
        :field="field"
        :errors="errs"
        :label="$t('doYouWant')"
        :radio-options="changeTypeOptions"
        :default-value="1"
        @on-change="(option) => handleChange(option.value)"
      ></RadioGroup>
    </Field>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { useInterval } from '@vueuse/core'
import { Field } from 'vee-validate'
import { onMounted, reactive, watch } from 'vue'
import RadioGroup from '@/components/SimpleForm/RadioGroup.vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['onResendOtp'])
const i18n = useI18n()

const changeTypeOptions = [
  { value: 1, label: 'sendSMS' },
  { value: 2, label: 'changeUsernameAndPassword' }
]

const TIME_LIMIT = 5

const otpConfig = reactive({
  isSent: false,
  showOtpTimer: false,
  timerHalfLife: TIME_LIMIT,
  showVerificationModal: false,
  intervalConfig: null,
  watcher: null,
  email: null
})

onMounted(() => {
  activateTimer()
})

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

function resetTimer() {
  if (otpConfig.intervalConfig) {
    otpConfig.watcher?.()
    otpConfig.isSent = false
    otpConfig.showOtpTimer = false
    otpConfig.timerHalfLife = TIME_LIMIT
    otpConfig.showVerificationModal = false
    otpConfig.intervalConfig = null
    otpConfig.watcher = null
    otpConfig.email = null
  }
}

function activateTimer() {
  otpConfig.isSent = true
  otpConfig.intervalConfig = useInterval(1000, { controls: true, immediate: true })

  otpConfig.watcher = watch(
    () => otpConfig.intervalConfig?.counter,
    () => {
      if (otpConfig.timerHalfLife === 0) {
        otpConfig.intervalConfig.reset()
        return
      }
      otpConfig.timerHalfLife -= 1
    }
  )
}

function onResendOtp() {
  resetTimer()
  activateTimer()
  emit('onResendOtp')
}
</script>

<style lang="scss" scoped></style>
